import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import NewsUpload from "../../components/pageManager/NewsUpload";

const NewsManagerPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <NewsUpload />
                </div>
            </div>
        </div>
    );
};

export default NewsManagerPage;
